import cl from 'classnames'
import { AnchorHTMLAttributes } from 'react'
import styles from './styles.module.scss'
import Link from 'next/link'

interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?:
    | 'primary'
    | 'secondary'
    | 'outline-primary'
    | 'outline-secondary'
    | 'outline-tertiary'
  href: string
}

export const HomeLinkButton = ({
  variant = 'primary',
  className,
  href,
  ...rest
}: Props) => {
  return (
    <Link
      href={href}
      className={cl(styles.buttonDefault, className)}
      data-variant={variant}
      {...rest}
      title={typeof rest.children === 'string' ? rest.children : undefined}
    />
  )
}
